import { ChangeEvent, memo, KeyboardEvent } from 'react';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';



interface FilterInputProps {
	searchText: string,
	onChange: (value: string) => void,
	onPressEnter: () => void,
}


const FilterInput = (props: FilterInputProps) => {
	const { searchText, onChange, onPressEnter } = props;

	return (
		<div className='popover-filter-input'>
			<Form.Control
				type='text'
				name='grid-popover-filter-input'
				value={searchText ? searchText : ''}
				className='app-form-style app-form-input'
				placeholder='Vyhledat...'
				onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
				onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => event.key === 'Enter' ? onPressEnter() : {}} />
			
			<div className='popover-filter-input-cancel' onClick={() => onChange('')}>
				<FontAwesomeIcon icon={faXmark} />
			</div>
		</div>
	)
}

export default memo(FilterInput);